<template>
  <div class="content dataStatistics">
    <van-row>
      <van-col :span="12" class="tabTitle" :class="search.queryType==1?'active':''" @click="search.queryType=1;newDataStatistics();"><span>按时间统计</span><em></em></van-col>
      <van-col :span="12" class="tabTitle" :class="search.queryType==2?'active':''" @click="search.queryType=2;newDataStatistics();"><span>按上传批次</span><em></em></van-col>
    </van-row>
    <div style="padding: .3rem;">
      <van-row type="flex" style="justify-content: space-between;">
        <van-col :span="12" v-if="search.queryType==2">
          <!-- <van-search v-model="value" placeholder="请输入搜索关键词" background="transparent" /> -->
          <div class="searchInput">
            <van-icon name="search" style="margin: 0 .1rem 0 .2rem;" />
            <input type="text" name="" v-model="search.importFileName" @blur="newDataStatistics">
          </div>
        </van-col>
        <van-col :span="10">
          <div class="date" @click="timeShow=true" v-if="search.queryType==1">
            <span v-text="formatDate(time)">2020-08-14</span>&nbsp;
            <van-icon name="arrow-down" />
          </div>
          <div class="date" @click="timeShow=true" v-if="search.queryType==2" style="justify-content: flex-end;">
            <span v-text="formatDate(time)">2020-08-14</span>&nbsp;
            <van-icon name="arrow-down" />
          </div>
        </van-col>
      </van-row>
    </div>
    <div style="padding: 0 .3rem;">
      <div class="list" v-for="(item,index) in list" :key="index">
        <!-- 批次名称 -->
        <van-row class="listHead" v-if="search.queryType==2"><strong class="listTitle" v-text="item.batchTitle">批次名称</strong></van-row>
        <van-row class="listBody" v-if="search.queryType==2">
          <van-col :span="6"><img src="../../assets/images/dataStatistics4.png" alt=""></van-col>
          <van-col :span="9">
            <div style="color: #3D7EFF;font-size: .46rem;line-height: .46rem;"><strong v-text="item.accuracyRate+'%'">20%</strong></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>准确率</span></div>
          </van-col>
          <van-col :span="9">
            <div style="color: #3D7EFF;font-size: .46rem;line-height: .46rem;"><strong v-text="item.connectionRate+'%'">20%</strong></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>接通率</span></div>
          </van-col>
        </van-row>
        <!-- 情况导入 -->
        <van-row class="listHead">
          <van-col :span="12" style="display: flex;align-items: center;">
            <strong class="listTitle">情况导入</strong>&nbsp;&nbsp;
            <img src="../../assets/images/dataStatistics1.png" alt="" @click="show = true">
          </van-col>
          <van-col :span="12" style="text-align: right;font-size: .26rem;" v-if="search.queryType==2">
            <font color="#ccc">上传人</font>&nbsp;&nbsp;<font color="#000" v-text="item.createUserName">王一尔</font>
          </van-col>
        </van-row>
        <van-row class="listBody" v-if="search.queryType==1" style="margin-bottom: .3rem;">
          <van-col :span="6"><img src="../../assets/images/dataStatistics4.png" alt=""></van-col>
          <van-col :span="9">
            <div style="color: #3D7EFF;font-size: .46rem;line-height: .46rem;"><strong v-text="item.accuracyRate+'%'">20%</strong></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>准确率</span></div>
          </van-col>
          <van-col :span="9">
            <div style="color: #3D7EFF;font-size: .46rem;line-height: .46rem;"><strong v-text="item.connectionRate+'%'">20%</strong></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>接通率</span></div>
          </van-col>
        </van-row>
        <van-row class="listBody">
          <van-col :span="4"><img src="../../assets/images/dataStatistics3.png" alt=""></van-col>
          <van-col :span="16" style="text-align: center;">
            <div style="color: #000000;font-size: .44rem;line-height: .46rem;"><strong v-text="item.importDataTotal">20000</strong></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>总量导入</span></div>
          </van-col>
          <van-col :span="24" style="margin-top: .5rem;text-align: center;">
            <van-row type="flex">
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .36rem;line-height: .36rem;"><span v-text="item.blacklistNumberCount">2000</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .15rem;"><span>黑名单</span></div>
                <em class="line"></em>
              </van-col>
              <!-- <van-col :span="6" style="position: relative;">
    							<div style="color: #000000;font-size: .36rem;line-height: .36rem;"><span>2000</span></div>
    							<div style="color: #515151;font-size: .24rem;margin-top: .15rem;"><span>空号</span></div>
    							<em class="line"></em>
    						</van-col> -->
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .36rem;line-height: .36rem;"><span v-text="item.validNumberCount">2000</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .15rem;"><span>新增线索</span></div>
                <em class="line"></em>
              </van-col>
              <van-col :span="8">
                <div style="color: #000000;font-size: .36rem;line-height: .36rem;"><span v-text="item.repeatNumberCount">2000</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .15rem;"><span>重复号码</span></div>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
        <!-- 拨打情况 -->
        <van-row class="listHead"><strong class="listTitle">拨打情况</strong></van-row>
        <van-row type="flex">
          <van-col :span="12" class="listBody">
            <div><img src="../../assets/images/dataStatistics5.png" alt=""></div>
            <div style="color: #000000;font-size: .36rem;line-height: .36rem;margin-top: .4rem;"><span v-text="item.noCalledNumberCount">1000</span><span>({{item.noCalledRate}}%)</span></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>未拨</span></div>
          </van-col>
          <div style="width: .2rem;"></div>
          <van-col :span="12" class="listBody">
            <div><img src="../../assets/images/dataStatistics5.png" alt=""></div>
            <div style="color: #000000;font-size: .36rem;line-height: .36rem;margin-top: .4rem;"><span v-text="item.calledNumberCount">1000</span><span>({{item.calledRate}}%)</span></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>已拨</span></div>
          </van-col>
        </van-row>
        <van-row class="listBody" style="margin-top: .2rem;">
          <van-col :span="24">
            <div style="color: #000000;font-size: .36rem;line-height: .36rem;"><span>{{item.answerNumberCount}}({{item.answerRate}}%)</span></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>已接</span></div>
          </van-col>
          <van-col :span="12" style="position: relative;margin-top: .35rem;">
            <div style="padding-right: .3rem;">
              <font color="#5A5A5A">已接有效</font>&nbsp;
              <font color="#000000" style="font-size: .24rem;" v-text="item.answerValidNumberCount">1000</font>
              <font color="#000000" style="font-size: .24rem;">({{item.answerValidRate}}%)</font>
            </div>
            <div style="padding-right: .3rem;margin-top: .25rem;">
              <font color="#919191" style="font-size: .235rem;">包含：待跟进、产品意向、完成邀约、报价、成交、未成交、不需要。</font>
            </div>
            <em class="line"></em>
          </van-col>
          <van-col :span="12" style="position: relative;margin-top: .35rem;">
            <div style="padding-left: .3rem;">
              <font color="#5A5A5A">已接无效</font>&nbsp;
              <font color="#000000" style="font-size: .24rem;" v-text="item.answerUnValidNumberCount">1000</font>
              <font color="#000000" style="font-size: .24rem;">({{item.answerUnValidRate}}%)</font>
            </div>
            <div style="padding-left: .3rem;margin-top: .25rem;">
              <font color="#919191" style="font-size: .24rem;">包含：风险号码，信息 不符。</font>
            </div>
          </van-col>
        </van-row>
        <van-row class="listBody" style="margin-top: .2rem;">
          <van-col :span="24">
            <div style="color: #000000;font-size: .36rem;line-height: .36rem;"><span>{{item.noAnswerNumberCount}}({{item.noAnswerRate}}%)</span></div>
            <div style="color: #515151;font-size: .26rem;margin-top: .22rem;"><span>未接</span></div>
          </van-col>
          <van-col :span="24" style="margin-top: .25rem;text-align: center;">
            <van-row type="flex" style="margin:.3rem 0;">
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.missedCallNumberCount}}({{item.missedCallRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>未接</span></div>
                <em class="line"></em>
              </van-col>
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.refuseNumberCount}}({{item.refuseNumberRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>拒接</span></div>
                <em class="line"></em>
              </van-col>
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.spaceNumberCount}}({{item.spaceNumberRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>空号</span></div>
              </van-col>
            </van-row>
            <van-row type="flex" style="margin:.3rem 0;">
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.shutdownNumberCount}}({{item.shutdownNumberRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>停机</span></div>
                <em class="line"></em>
              </van-col>
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.closeNumberCount}}({{item.closeNumberRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>关机</span></div>
                <em class="line"></em>
              </van-col>
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.busyNumberCount}}({{item.busyNumberCount}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>忙碌</span></div>
              </van-col>
            </van-row>
            <van-row type="flex" style="margin:.3rem 0;">
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.notAvailableNumberCount}}({{item.notAvailableNumberRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>无法接通</span></div>
                <em class="line"></em>
              </van-col>
              <van-col :span="8" style="position: relative;">
                <div style="color: #000000;font-size: .28rem;line-height: .28em;"><span>{{item.riskNumberCount}}({{item.riskNumberRate}}%)</span></div>
                <div style="color: #515151;font-size: .24rem;margin-top: .22rem;"><span>风险号码</span></div>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
      <div v-if="list.length<1" style="font-size: .32rem;color: #000;text-align: center;margin-top: 1.3rem;">
        <img src="../../assets/images/datanull.png" style="width: 4.7rem;display: block;margin: 0 auto .1rem auto;">
        <span>暂无数据</span>
      </div>
    </div>

    <van-popup v-model="timeShow" position="bottom">
      <van-datetime-picker v-model="time" type="date" title="日期" :visible-item-count="3" @confirm="timeConfirm" @cancel="timeConfirm" />
    </van-popup>
    <van-overlay :show="show" @click="show = false">
      <div style="background-color: #fff;width: 6.3rem;position: relative;margin: 1rem auto 0 auto;border-radius: .25rem;font-size: .28rem;padding: .7rem 0;">
        <van-icon name="close" @click="show = false" style="position: absolute;top: .2rem;right: .2rem;font-size: .6rem;" />
        <van-row style="font-size: .36rem;font-weight: bold;color: #000;">
          <van-col :span="7" style="text-align: right;">字段释义</van-col>
        </van-row>
        <van-row style="margin-top: .62rem;">
          <van-col :span="7" style="color: #3D7EFF;font-weight: bold;text-align: right;">准确率：</van-col>
          <van-col :span="15">已接号码的准确率； </van-col>
        </van-row>
        <van-row style="margin-top: .1rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">计算公式：</van-col>
          <van-col :span="15">已接有效号码/已接号码*100%</van-col>
        </van-row>
        <van-row style="margin-top: .3rem;">
          <van-col :span="7" style="color: #3D7EFF;font-weight: bold;text-align: right;">接通率：</van-col>
          <van-col :span="15">导入成功号码的拨打接通率。</van-col>
        </van-row>
        <van-row style="margin-top: .1rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">计算公式：</van-col>
          <van-col :span="15">已接号码/已拨号码(剔除掉风险号码、停机、关机、空号、）*100%。</van-col>
        </van-row>
        <van-row style="margin-top: .3rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">总导入量：</van-col>
          <van-col :span="15">总线索导入量。</van-col>
        </van-row>
        <van-row style="margin-top: .1rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">新增线索：</van-col>
          <van-col :span="15">导入成功，可供分配的号码。</van-col>
        </van-row>
        <van-row style="margin-top: .1rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">黑名单：</van-col>
          <van-col :span="15">电销卫士拦截的风险号码，拨打会有封号危险。</van-col>
        </van-row>
        <van-row style="margin-top: .1rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">空号错号：</van-col>
          <van-col :span="15">电销卫士识别的空号错号。</van-col>
        </van-row>
        <van-row style="margin-top: .1rem;">
          <van-col :span="7" style="font-weight: bold;text-align: right;">重复号码：</van-col>
          <van-col :span="15">在机构线索库中有重复的号码。</van-col>
        </van-row>
      </div>
    </van-overlay>
  </div>
</template>
<script>
// import {} from '../../api';
import { newDataStatistics } from '../../api';
export default {
  name: 'dataStatistics',
  data() {
    return {
      search: {
        queryType: 1,
        importFileName: "",
        queryDateStart: this.getDate(0),
        queryDateEnd: this.getDate(0)
      },
      time: new Date(this.getDate(0)),
      timeShow: false,
      show: false,
      list: []
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    getDate(days) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      // return [start.getFullYear()+"-"+(start.getMonth()+1)+"-"+start.getDate(), end.getFullYear()+"-"+(end.getMonth()+1)+"-"+end.getDate()];
      var myyear = start.getFullYear();
      var mymonth = start.getMonth() + 1;
      var myweekday = start.getDate();
      // return start.getFullYear()+"-"+(start.getMonth()+1)+"-"+start.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return (myyear + "-" + mymonth + "-" + myweekday);
    },
    formatDate(date) {
      // return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      const start = new Date(date);
      var myyear = start.getFullYear();
      var mymonth = start.getMonth() + 1;
      var myweekday = start.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return (myyear + "-" + mymonth + "-" + myweekday);
    },
    timeConfirm(v) {
      this.timeShow = false;
      this.search.queryDateStart = this.formatDate(v);
      this.search.queryDateEnd = this.formatDate(v);
      this.newDataStatistics();
    },
    newDataStatistics() {
      newDataStatistics(this.search).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
        } else {
          this.$toast("错误信息:" + res.message);
        }
      });
    }
  },
  mounted() {
    sessionStorage.setItem('token', this.getQueryString("token"));
    sessionStorage.setItem('newloginUser', this.getQueryString("newloginUser"));
    sessionStorage.setItem('actCode', this.getQueryString("actCode"));
    sessionStorage.setItem('ip', this.getQueryString("ip"));

    this.newDataStatistics();
  }
}
</script>
<style type="text/css">
.dataStatistics {
  font-family: PingFang SC, "Microsoft YaHei", 微软雅黑, Arial, Verdana,
    Sans-serif;
  font-size: 0.24rem;
  background-color: #f8f8f8;
}
.dataStatistics .tabTitle {
  height: 1rem;
  font-size: 0.32rem;
  color: #9c9c9c;
  text-align: center;
  line-height: 1rem;
  cursor: pointer;
  background-color: #fff;
  position: relative;
}
.dataStatistics .tabTitle.active {
  color: #000000;
}
.dataStatistics .tabTitle.active em {
  display: block;
  width: 0.5rem;
  height: 0.06rem;
  background-color: #3d7eff;
  border-radius: 0.03rem;
  position: absolute;
  bottom: 0;
  left: calc(50% - 0.25rem);
}
.dataStatistics .searchInput {
  width: 100%;
  height: 0.56rem;
  line-height: 0.56rem;
  font-size: 0.32rem;
  background-color: #fff;
  border-radius: 0.28rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dataStatistics .searchInput input {
  border: none;
  width: 75%;
  height: 0.4rem;
  font-size: 0.32rem;
  padding: 0;
  margin: 0;
}
.dataStatistics .date {
  font-size: 0.32rem;
  color: #000;
  font-weight: bold;
  display: flex;
  /*justify-content: flex-end;*/
  align-items: center;
  height: 0.56rem;
  cursor: pointer;
}
.dataStatistics .list {
  background-color: #fff;
  padding: 0.1rem 0.25rem 0.3rem 0.25rem;
  box-shadow: 0px 0.06rem 0.21rem 0px rgba(104, 153, 252, 0.08);
  border-radius: 0.25rem;
  margin-bottom: 0.2rem;
  /*box-sizing: border-box;*/
}
.dataStatistics .list .listHead {
  margin: 0.3rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dataStatistics .list .listTitle {
  font-size: 0.32rem;
  color: #000;
}
.dataStatistics .list .listBody {
  border-radius: 0.25rem;
  background-color: #f8f8f8;
  padding: 0.4rem 0.3rem;
}
.dataStatistics img {
  width: 0.34rem;
}
.dataStatistics em.line {
  width: 1px;
  height: 50%;
  background-color: #3d7eff;
  display: block;
  position: absolute;
  right: -1px;
  top: 25%;
}
</style>


// WEBPACK FOOTER //
// src/views/app/dataStatistics.vue


// WEBPACK FOOTER //
// src/views/app/dataStatistics.vue